<template>
    <section class="py-4">
        <div class="container">

            <div class="grid grid-cols-3 gap-x-3 gap-y-5">
                <a
                    v-for="item in categories"
                    :key="item.title"
                    :href="item.route"
                    class="group flex flex-col items-center text-center"
                >
                    <!-- картинка -->
                    <div class="w-[84px] h-[84px] rounded-2xl bg-grayBg overflow-hidden
                                flex items-center justify-center
                                transition group-active:scale-95">

                        <img
                            :src="item.image"
                            :alt="item.title"
                            class="w-full h-full object-contain p-2"
                            loading="lazy"
                        >
                    </div>

                    <!-- текст -->
                    <span class="mt-2 text-[13px] leading-[1.2] text-gray-900 font-medium">
                        {{ item.title }}
                    </span>
                </a>
            </div>

        </div>
    </section>
</template>

<script setup>
const categories = [
    { title: 'Железобетонные изделия', route: route('catalog', {type_slug: 'zhbi'}), image: '/assets/categories/1.webp' },
    { title: 'Бетонные смеси', route: route('catalog', {type_slug: 'beton'}), image: '/assets/categories/2.webp' },
    { title: 'Пиломатериалы', route: route('catalog', {type_slug: 'pilomaterialy'}), image: '/assets/categories/3.webp' },
    { title: 'Тротуарная плитка', route: route('catalog', {type_slug: 'trotuarnaya_plitka'}), image: '/assets/categories/4.webp' },
    { title: 'Нерудные материалы', route: route('comingSoon'), image: '/assets/categories/5.webp' },
    { title: 'Конструкции', route: route('comingSoon'), image: '/assets/categories/6.webp' },
];
</script>
